import { AnyAction, Dispatch } from "redux";
import { action } from "typesafe-actions";
import { IOnlineDsaLimit } from "./OnlineDsaLimit.types";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { IDate } from "../../components/Table/hooks/useDateFilter";
import { api } from "../../api/api";
import {
	closeLoaderWithMessage,
	openLoaderWithMessage,
	showMessage,
} from "../messages/messagesActions";

// List actions
export const FETCH_ONLINE_DSA_LIMIT_PROGRESS =
	"FETCH_ONLINE_DSA_LIMIT_PROGRESS";
export const FETCH_ONLINE_DSA_LIMIT_SUCCESS = "FETCH_ONLINE_DSA_LIMIT_SUCCESS";
export const FETCH_ONLINE_DSA_LIMIT_FAILURE = "FETCH_ONLINE_DSA_LIMIT_FAILURE";

export const fetchOnlineDsaLimitProgress = () =>
	action(FETCH_ONLINE_DSA_LIMIT_PROGRESS);

export const fetchOnlineDsaLimitSuccess = (
	data: IOnlineDsaLimit[],
	totalRecords: number
) => action(FETCH_ONLINE_DSA_LIMIT_SUCCESS, { data, totalRecords });

export const fetchOnlineDsaLimitFailure = (error: string) =>
	action(FETCH_ONLINE_DSA_LIMIT_FAILURE, error);

export const fetchOnlineDsaLimitAsync =
	(
		pageNumber: number,
		rowsInPerPage: number,
		status: string,
		date: IDate,
		online_dsa_name?: number | null,
		package_id?: string,
		user_id?: string
	): ThunkAction<void, IStoreState, {}, AnyAction> =>
	async (dispatch, getState) => {
		try {
			dispatch(fetchOnlineDsaLimitProgress());
			let url = "";
			if (status !== "-1") {
				url = "&status=" + status;
			}
			if (online_dsa_name) {
				url += "&user_id=" + online_dsa_name;
			}
			if (package_id) {
				url += "&package_id=" + package_id;
			}
			if (user_id) {
				url += "&user_id=" + user_id;
			}
			let finalUrl =
				`get-online-dsa-activation-limit?pageNo=${pageNumber}&itemsPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}` +
				url;
			const res = await api.get(finalUrl);
			const data: IOnlineDsaLimit[] = res.data.result;
			const totalRecords = res.data.totalRecords;
			dispatch(
				showMessage({
					message: "Online DSA Limit fetched successfully",
					type: "success",
					displayAs: "snackbar",
				})
			);
			dispatch(fetchOnlineDsaLimitSuccess(data, totalRecords));
		} catch (error: any) {
			dispatch(fetchOnlineDsaLimitFailure(error.message));
			dispatch(
				showMessage({
					message: error.response.data.message,
					type: "error",
					displayAs: "snackbar",
				})
			);
		}
	};

// Single record actions
export const FETCH_SINGLE_ONLINE_DSA_LIMIT_PROGRESS =
	"FETCH_SINGLE_ONLINE_DSA_LIMIT_PROGRESS";
export const FETCH_SINGLE_ONLINE_DSA_LIMIT_SUCCESS =
	"FETCH_SINGLE_ONLINE_DSA_LIMIT_SUCCESS";
export const FETCH_SINGLE_ONLINE_DSA_LIMIT_FAILURE =
	"FETCH_SINGLE_ONLINE_DSA_LIMIT_FAILURE";

// Single record action creators
export const fetchSingleOnlineDsaLimitProgress = () =>
	action(FETCH_SINGLE_ONLINE_DSA_LIMIT_PROGRESS);

export const fetchSingleOnlineDsaLimitSuccess = (data: IOnlineDsaLimit) =>
	action(FETCH_SINGLE_ONLINE_DSA_LIMIT_SUCCESS, data);

export const fetchSingleOnlineDsaLimitFailure = (error: string) =>
	action(FETCH_SINGLE_ONLINE_DSA_LIMIT_FAILURE, error);

export const fetchSingleOnlineDsaLimitAsync =
	(id: string): ThunkAction<void, IStoreState, {}, AnyAction> =>
	async (dispatch) => {
		try {
			dispatch(fetchSingleOnlineDsaLimitProgress());
			const res = await api.get(`get-online-dsa-activation-limit/${id}`);
			const data: IOnlineDsaLimit = res.data.result;
			dispatch(
				showMessage({
					message: "Online DSA Limit fetched successfully",
					type: "success",
					displayAs: "snackbar",
				})
			);
			dispatch(fetchSingleOnlineDsaLimitSuccess(data));
		} catch (error: any) {
			dispatch(fetchSingleOnlineDsaLimitFailure(error.message));
			dispatch(
				showMessage({
					message: error.response.data.message,
					type: "error",
					displayAs: "snackbar",
				})
			);
		}
	};

export const upsertOnlineDsaLimit = (
	payload: IOnlineDsaLimit,
	onCallback: (isSuccess: boolean, grnUUID?: string) => void
) => {
	return async (dispatch: Dispatch) => {
		try {
			dispatch(openLoaderWithMessage("Updating Online DSA Limit..."));
			const res = await api.post("upsert-online-dsa-activation-limit", payload);

			onCallback(true, res.data.data);
			dispatch(
				showMessage({
					message: "Online DSA Limit updated successfully",
					type: "success",
					displayAs: "snackbar",
				})
			);
		} catch (error: any) {
			onCallback(false, error.response.data.message);
			dispatch(
				showMessage({
					message: error.response.data.message,
					type: "error",
					displayAs: "snackbar",
				})
			);
		} finally {
			dispatch(closeLoaderWithMessage());
		}
	};
};

export const CLEAR_ONLINE_DSA_LIMIT = "CLEAR_ONLINE_DSA_LIMIT";
export const CLEAR_ONLINE_DSA_LIMIT_STATE = "CLEAR_ONLINE_DSA_LIMIT_STATE";
export const clearOnlineDsaLimit = () => action(CLEAR_ONLINE_DSA_LIMIT);
export const clearOnlineDsaLimitState = () =>
	action(CLEAR_ONLINE_DSA_LIMIT_STATE);
